import SalaryList from '@/controllers/salary/salary-list.js';

export default {
  extends: SalaryList,
}
